<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8" class="text-justify">
        <h2 class="display-2 text-center mb-4 text-secondary">SPARQL Query Examples</h2>
        <p class="text-body-1">
          Below are several example SPARQL queries. Click on a button to execute the query on the Wikidata SPARQL
          endpoint.
          <br />
          You can also craft your own queries simply using text-to-sparql tools available online such as <a href='https://grasp.cs.uni-freiburg.de/'>GRASP</a> or <a href='https://spinach.genie.stanford.edu/'>Spinach</a>.        
        </p>
        <!-- Query List -->
        <v-list class='mt-2'>
          <v-list-item-group>
            <v-list-item v-for="(example, index) in exampleQueries" :key="index">
              <v-list-item-content>
                <v-card outlined>
                  <v-card-title class="d-flex flex-column flex-md-row justify-space-between text-secondary">
                    <span>{{ example.name }}</span>
                  </v-card-title>
                  <v-card-text>
                    <div style="overflow-x: auto; word-wrap: break-word;">
                      <pre>{{ example.query }}</pre>
                    </div>
                    <v-btn class='mt-3' :href="generateWikidataUrl(example.query)" target="_blank" color="primary" small>
                      Execute
                    </v-btn>
                  </v-card-text>
                </v-card>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <!-- Dump Section -->
      <!-- <v-col cols="12" md="8" class="text-justify">
        <h1 class="text-center">Planets Data Dump</h1>
        <p class="text-body-1">
          Here is a JSON dump of planet data. The file contains detailed information about the planets
          in the Star Wars universe, fetched using SPARQL queries.
        </p>
        <v-col class="text-center">
          <v-btn
            :href="dumpUrl"
            :disabled="!dumpUrl"
            ownload="planets.json"
            color="primary"
          >
            Download Planets JSON Dump
          </v-btn>
        </v-col>
      </v-col> -->
    </v-row>
  </v-container>
</template>

<script>
import { ref, onMounted } from "vue";
import apiClient from "@/apiClient";
import { useHead } from '@unhead/vue';

export default {
  name: "SPARQLPage",
  setup() {
    const exampleQueries = ref([]);
    // const dumpUrl = ref("");

    useHead({
      title: "Star Wars SPARQL Queries – Explore Wikidata with Ready-to-Use Examples",
      meta: [
        {
          name: "description",
          content: "Access a collection of SPARQL query examples to explore Star Wars data on Wikidata. Learn how to execute queries and retrieve structured information about planets, characters, factions, and more from the galactic knowledge base.",
        },
        {
          property: "og:title",
          content: "Star Wars SPARQL Queries – Explore Wikidata with Ready-to-Use Examples",
        },
        {
          property: "og:description",
          content: "Browse SPARQL query examples for fetching Star Wars data from Wikidata. Execute these queries directly on the Wikidata SPARQL endpoint to uncover detailed galactic insights.",
        },
        {
          property: "og:url",
          content: "https://sw-holonet.com/sparql",
        },
        { property: "og:type", content: "website" },
        {
          name: "twitter:title",
          content: "Star Wars SPARQL Queries – Wikidata Examples",
        },
        {
          name: "twitter:description",
          content: "Explore ready-to-use SPARQL queries for Star Wars data on Wikidata. Retrieve structured information about the galaxy’s planets, characters, and factions.",
        },
        { name: "twitter:card", content: "summary" },
        {
          name: "keywords",
          content: "SPARQL queries, Star Wars Wikidata, Wikidata SPARQL, Star Wars data, query examples, galactic knowledge base, structured data, Star Wars planets, Star Wars characters, Star Wars factions",
        },
      ],
    });

    // Fetch example queries
    onMounted(() => {
      apiClient
        .get("/api/example-queries")
        .then((response) => {
          exampleQueries.value = response.data;
        })
        .catch((error) => {
          console.error("Error fetching example queries", error);
        });

      // Fetch dump URL
      // fetchDumpUrl();
    });

    // Fetch dump URL
    // const fetchDumpUrl = () => {
    //   apiClient
    //     .get("/api/planets-dump")
    //     .then((response) => {
    //       const baseUrl = window.location.origin; // This gives the correct domain (e.g., http://example.com)
    //       dumpUrl.value = `${baseUrl}${response.data.url}`;
    //     })
    //     .catch((error) => {
    //       console.error("Error fetching dump URL:", error);
    //       dumpUrl.value = "#"; // Fallback in case of an error
    //     });
    // };

    // Generate the Wikidata query URL
    const generateWikidataUrl = (query) => {
      const encodedQuery = encodeURIComponent(query);
      return `https://query.wikidata.org/#${encodedQuery}`;
    };

    return {
      exampleQueries,
      generateWikidataUrl
      //dumpUrl,
      //fetchDumpUrl,
    };
  },
};

</script>

<style>
.truncate-title {
  display: block;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}

@media (max-width: 600px) {
  .truncate-title {
    font-size: 14px;
  }

  .v-card-title {
    flex-direction: column;
    align-items: flex-start;
  }

  .v-card-title span {
    margin-bottom: 8px;
  }

  .v-btn {
    align-self: flex-start;
  }
}
</style>
